// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFound_wrapper__x39VU","btn":"NotFound_btn__P2Bcc"};